import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Menu from "../Menu";
import {NavLink} from "react-router-dom";
import GenerateURL from "../../utils/generateURL";
import {API_FOOTER_LICENCE_TEXT, INDEX_ROUTE} from "../../utils/consts";
import parse from "html-react-parser";

import logo from "../../img/logo.svg";
import back_to_top from "../../img/back_to_top.png";
import Search from "../Search";
import {useFetching} from "../../hooks/useFetching";
import ApiFooterLicenceText from "../../services/FooterLicenceText";
import {useWindowSize} from "../../hooks/useWindowSize";
import {observer} from "mobx-react-lite";
import {MobileMenuContext} from "../../App";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";
import device from "current-device";

const Footer = () => {
    const {t} = useTranslation();
    const size = useWindowSize();
    const [licenceText, setLicenceText] = useState('');
    // const [licenceText, setLicenceText] = useState('<div>ЛИЦЕНЗИАТ, MACH LTD, С РЕГИСТРАЦИОННЫМ АДРЕСОМ <a href="https://www.google.com/maps/search/86+Merchants+Street,+Valletta?entry=gmail&amp;source=g" target="_blank">86 MERCHANTS STREET, VALLETTA</a>, VLT 1177, MALTA, ИМЕЕТ ЛИЦЕНЗИЮ И РЕГУЛИРУЕТСЯ УПРАВЛЕНИЕМ ПО АЗАРТНЫМ ИГРАМ МАЛЬТЫ (MGA) ДЛЯ ДЕЯТЕЛЬНОСТИ B2B. ЛИЦЕНЗИЯ № MGA/XX/XX/XXXX ВЫДАНА XX/XX/XXXX</div> <div>&nbsp;</div> <div>©2022 MACH LTD. ВСЕ ПРАВА ЗАЩИЩЕНЫ.</div>');

    const [bottom, setBottom] = useState(32);
    const [display, setDisplay] = useState('none');
    const [logoOpacity, setLogoOpacity] = useState(true);
    const [mobileMenu, setMobileMenu] = useContext(MobileMenuContext);

    const [FunctionApiFooterLicenceText] = useFetching(async () => {
        const response = await ApiFooterLicenceText.getApiFooterLicenceText(API_FOOTER_LICENCE_TEXT);
        setLicenceText(response.data.text);
    });

    useEffect(() => {
        FunctionApiFooterLicenceText();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const backToTop = () => {
        if (window.pageYOffset > 0) {
            window.scrollBy(0, -80);
            setTimeout(backToTop, 0);
        }
    };

    useEffect(() => {
        const BackToTopDisplay = () => {
            if (document.querySelector('.footer')) {
                setBottom((window.scrollY + window.innerHeight) > (document.body.offsetHeight - document.querySelector('.footer').offsetHeight)
                    ? device.mobile() || device.tablet() || document.body.clientWidth <= 1280
                        ? ((window.scrollY + window.innerHeight) - (document.body.offsetHeight - document.querySelector('.footer').offsetHeight)) + 32
                        : ((window.scrollY + window.innerHeight) - (document.body.offsetHeight - document.querySelector('.footer').offsetHeight))
                    : 32);
            }
            if (document.body.clientWidth > 1280) {
                setDisplay(((window.innerHeight * 2) > window.scrollY + window.innerHeight) || (window.scrollY + window.innerHeight > document.body.offsetHeight - document.querySelector('.footer').offsetHeight) ? 'none' : 'flex')
            } else {
                setDisplay(((window.innerHeight * 2) > window.scrollY + window.innerHeight) ? 'none' : 'flex')
            }
        };
        document.addEventListener('scroll', BackToTopDisplay);

        return () => {
            document.removeEventListener('scroll', BackToTopDisplay);
        }
}, [size]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <footer className="footer">
                <div className="row">
                    <div className="left_block">
                        <NavLink className={`logo ${document.body.clientWidth <= 567 ? logoOpacity ? '' : 'opacity' : ''}`} to={GenerateURL(INDEX_ROUTE)}>
                            <img src={logo} alt="logo"/>
                        </NavLink>
                    </div>
                    {document.body.clientWidth > 1280 && <Menu />}
                    <div className="right_block">
                        {document.body.clientWidth > 1280 && <div
                            className="back_to_top"
                            onClick={backToTop}
                        >
                            <span>{t('Back To Top')}</span>
                            <img src={back_to_top} alt={t('Back To Top')}/>
                        </div>}
                        <div className="right_block_content">
                            {!mobileMenu && <Search logoOpacity={logoOpacity} setLogoOpacity={setLogoOpacity} />}
                            {document.body.clientWidth <= 1280 && <button
                                    type="button"
                                    className={`mobile_click ${mobileMenu ? 'open' : ''}`}
                                    onClick={() => {
                                        if (mobileMenu) {
                                            ScrollToPositionFixed(true);
                                            setMobileMenu(false);
                                        } else {
                                            setMobileMenu(!mobileMenu);
                                            ScrollToPositionFixed(false, window.pageYOffset);
                                        }
                                    }}
                                ><span/><span/><span/>
                            </button> }
                        </div>
                    </div>
                </div>
                {licenceText &&
                <div className="row">
                    <div className="bottom">
                        <div className="editor">
                            {parse(licenceText)}
                        </div>
                    </div>
                </div>
                }
            </footer>
            <div
                className="back_to_top cube"
                onClick={backToTop}
                style={{
                    display: display,
                    bottom: `${!device.desktop() && bottom}px`
                }}

            >
                <span>{t('Back To Top')}</span>
                <img src={back_to_top} alt={t('Back To Top')}/>
            </div>
        </>
    );
};

export default observer(Footer);